import React, { FC } from 'react';
import classNames from 'classnames';

import { DictionaryData, useTranslation } from 'app/lang';

import { MATCH_HEADER } from '../../../../../../constants';

import dictionary from './MatchLine.dictionary.json';

import styles from './MatchLine.module.scss';

// ---

type MatchLineProps = {
  title: DictionaryData;
  expanded: boolean;
  hasStakeSlots: boolean;
  className?: string;
};

const MatchLine: FC<MatchLineProps> = ({
  title,
  expanded,
  hasStakeSlots,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.matchLine, className)}>
      {hasStakeSlots ? (
        <>
          {t(title)}
          <div className={styles.subtext}>
            {t(expanded ? MATCH_HEADER.subtitleExpanded : MATCH_HEADER.subtitleCollapsed)}
          </div>
        </>
      ) : (
        <span>{t(dictionary.noAdditionalStakes)}</span>
      )}
    </div>
  );
};

export default MatchLine;
